"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.estoniaTranslations = void 0;
var _types = require("../../../types");
const estoniaTranslations = exports.estoniaTranslations = {
  [_types.ErrorPageTranslationKey.headline]: ' Vabandame!',
  [_types.ErrorPageTranslationKey.buttonText]: ' Tagasi',
  [_types.ErrorPageTranslationKey.text]: 'See lehekülg ei ole hetkel kättesaadav',
  [_types.ErrorPageTranslationKey.notFound]: 'Lehekülg, mida otsite, ei tööta praegu',
  [_types.ErrorPageTranslationKey.unauthorized]: 'Leheküljele, mida proovite külastada, on piiratud juurdepääs ja kõiki kriteeriume ei ole täidetud.',
  [_types.ErrorPageTranslationKey.contactSupportTeam]: "Võtke ühendust Oriflame'i tugimeeskonnaga e-posti teel:",
  [_types.ErrorPageTranslationKey.rejectedUrl]: 'Taotletud URL lükati tagasi!'
};
